import {
  ORG_PROFILE_SET_PROFILE_DATA,
  ORG_PROFILE_SET_ORG_DETAILS,
  ORG_PROFILE_SET_ORG_MASTER,
  ORG_PROFILE_LOADING,
  TOGGLE_SHOW_HOME_PAGE,
} from './constants';
import {
  fetchOrgMaster,
  fetchOrganisationDetails,
  fetchOrgProfileDetails,
} from 'src/api/organisationProfiling';
import { message } from 'antd';
import { useReduxAction, useReduxActions } from 'src/hooks/useRedux';

export const setOrgDetails = data => async (dispatch) => {
  dispatch({
    data,
    type: ORG_PROFILE_SET_ORG_DETAILS,
  });
};
export const setOrgMaster = data => async (dispatch) => {
  dispatch({
    data,
    type: ORG_PROFILE_SET_ORG_MASTER,
  });
};

export const loadOrganisationProfile = body => async (dispatch, store) => {
  dispatch({
    type: ORG_PROFILE_LOADING,
    value: true,
  });
  const orgProfile = await fetchOrgProfileDetails(body);
  if (orgProfile.isSuccess) {
    dispatch({
      data: orgProfile.data,
      type: ORG_PROFILE_SET_PROFILE_DATA,
    });
  }
  dispatch({
    type: ORG_PROFILE_LOADING,
    value: false,
  });
};

export const initOrgProfile = body => async (dispatch) => {
  dispatch({
    type: ORG_PROFILE_LOADING,
    value: true,
  });
  const master = await fetchOrgMaster();
  const orgDetails = await fetchOrganisationDetails();
  if (master.isSuccess && orgDetails.isSuccess) {
    dispatch(setOrgMaster(master.data));
    dispatch(setOrgDetails(orgDetails.data));
    await dispatch(loadOrganisationProfile(body));
  } else {
    message.error(master.errorMessage);
  }
  dispatch({
    type: ORG_PROFILE_LOADING,
    value: false,
  });
};

export const toggleShowHomePage = () => {
  return {
    type: TOGGLE_SHOW_HOME_PAGE,
  };
};

export const useOrganisationProfileActions = () => {
  return useReduxActions({
    setOrgDetails,
    setOrgMaster,
    loadOrganisationProfile,
    initOrgProfile,
  });
};
